import React, { useState, useLayoutEffect } from "react";
import MenuBar from "../../Components/MenuBar/MenuBar.js";
import MobileNavBar from "../../Components/Navbar/MobileNavBar.js";
import CollegeMobileNavBar from "../../Components/Navbar/CollegeMobileNavBar";
import MobileDetect from "mobile-detect";

export default function SwitchMenuBar(props) {
  const {
    isViewAsTeacher,
    isTeacherInfo,
    isViewAsCollege,
    isViewAsPersonnel,
    viewbookings,
  } = props;
  // console.log("props in menu bar switcher >>>>>>>>>", {
  //   isViewAsTeacher,
  //   isViewAsCollege,
  //   isViewAsPersonnel,
  // });

  const btn_jump_profile = (e) => {
    e.preventDefault();
    this.props.history.push("/");
  };

  // Detect window size change
  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  function ShowWindowDimensions(props) {
    const [width, height] = useWindowSize();
    let menu = null;
    let type = new MobileDetect(window.navigator.userAgent)

    if (isViewAsTeacher) {
      if (width < 450 && type.os() !== "iOS") {
        menu = (
          <MobileNavBar
            isViewAsTeacher={isViewAsTeacher}
            isTeacherInfo={isTeacherInfo}
          />
        );
      } else {
        menu = <MenuBar isViewAsTeacher={isViewAsTeacher} />;
      }
    } else if (isViewAsCollege) {
      if (width < 450 && type.os() !== "iOS") {
        menu = <CollegeMobileNavBar viewbookings={viewbookings} />;
      } else {
        menu = (
          <MenuBar
            isViewAsCollege={isViewAsCollege}
            viewbookings={viewbookings}
          />
        );
      }
    }
    // added another condition here for personnel menu - lieh
    else if (isViewAsPersonnel) {
      if (width < 450 && type.os() !== "iOS") {
        // gotta change this later to MobileNavBar for Personnel - lieh
        menu = (
          <CollegeMobileNavBar
            isViewAsPersonnel={isViewAsPersonnel}
            viewbookings={viewbookings}
          />
        );
      } else {
        menu = (
          <MenuBar
            isViewAsPersonnel={isViewAsPersonnel}
            viewbookings={viewbookings}
          />
        );
      }
    } else {
      if (width < 450 && type.os() !== "iOS") {
        menu = <MobileNavBar />;
      } else {
        menu = <MenuBar />;
      }
    }
    return menu;
  }
  //
  return <div className="switch-menu-bar">{ShowWindowDimensions()}</div>;
}
